$(document).ready(function() {
  $(document).on('click', 'a[href^="#"]', function(e) {
    e.preventDefault();
    var targetId = $(this).attr('href').replace('#', '');
    var target = $('#' + targetId);

    var className = $(this).attr('class');
    if(className == 'skip-link') {
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top,
        }, 1000, 'swing');

        // focus first tabindex into .main
        $('.main').find('[tabindex="0"]').first().focus();
      }
    } else {
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - $('header').outerHeight(),
        }, 800, 'swing');
      }
    }
  });
});

